import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxFileDropModule } from 'ngx-file-drop';
import { AceModule } from './ACE/ace.module';
import { AceBadgeComponent } from './ACE/Badge/badge.component';
import { AceLoaderComponent } from './ACE/Loader/loader.component';
import { CarouselComponent } from './Carousel/carousel.component';
import { CurrencyInputComponent } from './Currency/currencyInput.component';
import { DirectivesModule } from './Directives/directives.module';
import { SharedPipesModule } from './Pipes/shared-pipes.module';
import { HelpModule } from './Help-Tooltip/help.module';
import { SelectModule } from './Select/select.module';
import { ModalWrapperModule } from './Modal-Wrapper/modalWrapper.module';
import { TriStateCheckboxModule } from './Tri-State-Checkbox/triStateCheckbox.module';
import { WsTypeaheadModule } from './Typeahead/typeahead.module';
import { BreadCrumbsComponent } from './Bread-Crumb/breadCrumbs.component';
import { BulkUpdateActionComponent } from './Bulk-Update/Update-Action/bulkUpdateAction.component';
import { ParentheticalCurrencyComponent } from './Currency/parenthetical-currency.component';
import { FilePickerComponent } from './FilePicker/filePicker.component';
import { MultiSelectComponent } from './Multi-Select/multiSelect.component';
import { PicklistComponent } from './Picklist/picklist.component';
import { SwitchComponent } from './Switch/switch.component';
import { WeissmanDatetimeComponent } from './Weiss-Datepicker/weissman-datetime.component';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { WeissmanPanelComponent } from './Weissman-Panel/weissmanPanel.component';
import { PanelChevronComponent } from './Weissman-Panel/panel.chevron.component';
import { CurrencyMaskModule } from './Currency/Mask/currencyMask.module';

const hybridAdapterUtility = new HybridAdapterUtility();

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        NgxFileDropModule,
        DirectivesModule,
        SharedPipesModule,
        HelpModule,
        ModalWrapperModule,
        SelectModule,
        TriStateCheckboxModule,
        WsTypeaheadModule,
        AceModule,
        CurrencyMaskModule,
        // Standalone Components
        WeissmanDatetimeComponent,
        CurrencyInputComponent,
        PanelChevronComponent,
        MultiSelectComponent,
        SwitchComponent,
        BreadCrumbsComponent,
        PicklistComponent,
        CarouselComponent,
        FilePickerComponent,
    ],
    declarations: [BulkUpdateActionComponent, ParentheticalCurrencyComponent, WeissmanPanelComponent],
    exports: [
        // Modules
        DirectivesModule,
        SharedPipesModule,
        HelpModule,
        ModalWrapperModule,
        SelectModule,
        TriStateCheckboxModule,
        WsTypeaheadModule,
        AceModule,
        // Components
        BreadCrumbsComponent,
        BulkUpdateActionComponent,
        ParentheticalCurrencyComponent,
        FilePickerComponent,
        MultiSelectComponent,
        PicklistComponent,
        SwitchComponent,
        WeissmanDatetimeComponent,
        WeissmanPanelComponent,
        PanelChevronComponent,
        CarouselComponent,
        CurrencyInputComponent,
    ],
})
export class UILibModule {
    static setupModule(): void {
        SelectModule.setupModule();
        HelpModule.setupModule();
        hybridAdapterUtility.downgradeNg2Component('weissmanDatetime', WeissmanDatetimeComponent);
        hybridAdapterUtility.downgradeNg2Component('weissmanPanel', WeissmanPanelComponent);
        hybridAdapterUtility.downgradeNg2Component('wsBreadCrumbs', BreadCrumbsComponent);
        hybridAdapterUtility.downgradeNg2Component('wsAceBadge', AceBadgeComponent);
        hybridAdapterUtility.downgradeNg2Component('wsAceLoader', AceLoaderComponent);
    }
}
